module.exports = __webpack_public_path__ + "static/media/timelapse150.6b296113.mp4";